module.exports = __webpack_public_path__ + "static/media/ic-beamer.9e6e05a1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-beamer.svg
// module id = 600
// module chunks = 14